<template>
  <div>
    <el-table
      :data="items"
      size="small"
      class="mt-10"
      v-loading="loading"
      border
    >
      <el-table-column
        align="center"
        label="成品分类"
        prop="name"
      ></el-table-column>
      <el-table-column align="center" label="规格型号" prop="model_number">
        <template slot-scope="scope">{{
          scope.row.model_number || '无'
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="工时阶段" prop="step">
        <template slot-scope="scope">
          {{ ProductHourStepMap[scope.row.step] }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="数量" prop="count">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="
              $router.push(
                `/${
                  category == 1 ? 'products' : 'instruments'
                }?product_template_id=${
                  scope.row.product_template_id
                }&hour_step=${scope.row.step}`,
              )
            "
            >{{ scope.row.count }}</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ProductHourStepMap } from '@/config/global'
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
  data() {
    return {
      ProductHourStepMap,
    }
  },
}
</script>